import { Wind, CloudRain, Cloud, Thermometer, Umbrella, Gauge, Droplets } from "lucide-react";

export const LAYERS = [
  { key: "wind", label: "Angin", Icon: Wind, source: "Open-Meteo" },
  { key: "radar", label: "Radar Hujan", Icon: CloudRain, source: "RainViewer" },
  { key: "precip", label: "Curah Hujan", Icon: Umbrella, source: "OpenWeatherMap" },
  { key: "clouds", label: "Awan", Icon: Cloud, source: "OpenWeatherMap" },
  { key: "temp", label: "Suhu", Icon: Thermometer, source: "Open-Meteo" },
  { key: "pressure", label: "Tekanan", Icon: Gauge, source: "Open-Meteo" },
  { key: "humidity", label: "Kelembapan", Icon: Droplets, source: "Open-Meteo" },
];

export const LayerPicker = ({ layer, onChange }) => (
  <div className="windy-layers" data-testid="layer-picker">
    {LAYERS.map(({ key, label, Icon }) => {
      const active = layer === key;
      return (
        <button
          key={key}
          data-testid={`radar-layer-${key}`}
          onClick={() => onChange(key)}
          title={label}
          className={`windy-layer-btn ${active ? "is-active" : ""}`}
        >
          <Icon className="w-4 h-4" />
          <span>{label}</span>
        </button>
      );
    })}
  </div>
);
